/**
 * Application Constants
 * Centralized constants for app settings, versions, and global configurations
 */

// Date and Time Settings
export const DATE_TIME_CONFIG = {
  // Sunday (0 = Sunday, 1 = Monday, etc.).
  // Leftover: Daily Cost Monday +1 day window (deprecated).
  START_OF_WEEK: 0,
  END_OF_WEEK: 6, // Saturday (0 = Sunday, 1 = Monday, etc.)
  TIMEZONE: "America/Los_Angeles", // Pacific Time
};

// Development Configuration
export const DEV_CONFIG = {
  LOCAL_HOST_URL: "http://127.0.0.1:3000",
  IS_DEVELOPMENT: () => window.location.origin === DEV_CONFIG.LOCAL_HOST_URL,
};

// UI Layout Constants
export const LAYOUT_CONFIG = {
  BREAKPOINTS: {
    DESKTOP: "1024px",
    FULL: "1322px",
    DISPATCH: "1024px",
    DISPATCH_WEEKENDS: "1282px",
  },
};

// File and Upload Settings
export const FILE_CONFIG = {
  MAX_FILE_SIZE: 20 * 1024 * 1024, // 20MB (general file size limit)
  MAX_VIDEO_SIZE: 100 * 1024 * 1024, // 100MB (video file size limit)

  // Image file types supported for upload
  ALLOWED_IMAGE_TYPES: [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/heic",  // iPhone photos
    "image/heif",  // iPhone photos
  ],

  // Video file types supported for upload
  ALLOWED_VIDEO_TYPES: [
    "video/mp4",
    "video/quicktime",  // .mov files (iPhone videos)
    "video/webm",
  ],

  // Document types
  ALLOWED_DOCUMENT_TYPES: [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ],
};

// Feature Flags
export const FEATURE_FLAGS = {
  // Enable Sentry in production builds (npm run build, build:dev, build:prod)
  // Disable in local development (npm start)
  ENABLE_SENTRY: process.env.NODE_ENV === "production",
  ENABLE_DEBUG_MODE: process.env.NODE_ENV === "development",
  ENABLE_SERVICE_WORKER: process.env.NODE_ENV === "production",
  ENABLE_ANALYTICS: process.env.NODE_ENV === "production",
  // Enable version check in production builds to detect new deployments
  ENABLE_VERSION_CHECK: process.env.NODE_ENV === "production",
};

// Version Check Configuration
export const VERSION_CHECK_CONFIG = {
  // Check interval in milliseconds (default: 10 minutes)
  CHECK_INTERVAL: 30 * 60 * 1000,
  // Version file URL (matches homepage config and nginx location)
  VERSION_URL: "/app/version.json",
};

// User facing messages are here. Please use these for anything the user might see.
// Error Messages
export const ERROR_MESSAGES = {
  NO_ROLES:
    "You currently don't have any roles assigned to your account. Please contact the office to set up appropriate access permissions.",
  NETWORK_ERROR: "Network error. Please check your connection and try again.",
  UNAUTHORIZED: "You are not authorized to access this resource.",
  NOT_FOUND: "The requested resource could not be found.",
  SERVER_ERROR: "An internal server error occurred. Please try again later.",
};

// Success Messages
export const SUCCESS_MESSAGES = {
  DATA_SAVED: "Data saved successfully",
  FILE_UPLOADED: "File uploaded successfully",
  USER_UPDATED: "User information updated successfully",
  LOGOUT: "Logged out successfully",
};
